/**
 * Quem ve cada parte de Configuracoes > Analise de credito.
 *
 * Os parametros do motor pedem `credito.parametro.view`. Pareceres, alcadas e
 * bloqueios (C-ALC) pedem a funcionalidade `credito.analise` e a leitura da matriz de
 * alcadas (`alcadas.matriz.view`) ou da politica de credito (`credito.politica.view`):
 * cada assunto da secao confere de novo a propria permissao, e o servidor confere
 * tudo.
 */

type Pode = (permissao: string) => boolean;

export function vePareceresEAlcadas(can: Pode, hasFeature: Pode): boolean {
  return (
    hasFeature('credito.analise') &&
    (can('alcadas.matriz.view') || can('credito.politica.view'))
  );
}

/** A aba "Analise de credito" aparece para quem ve alguma das partes. */
export function veAnaliseDeCredito(can: Pode, hasFeature: Pode): boolean {
  return can('credito.parametro.view') || vePareceresEAlcadas(can, hasFeature);
}
